import { useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';

import JsonView from 'react18-json-view';

import { recheckTransaction } from 'api/Transaction';

import { iaRa } from 'lib/helpers/utility';
import useLoading from 'lib/hooks/useLoading';

import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';
import { showAlert } from 'components/shared/Alert/Alert';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

const TransactionResponseModal = ({ isOpen, handleClose, item }) => {
  const navigate = useNavigate();
  const [selectedTxn, setSelectedTxn] = useState(item);

  const transactionId = item?.id;

  const { loading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    setSelectedTxn(item);
  }, [item]);

  const transactionCheck = useCallback(async () => {
    if (loading) return;
    startLoading();
    try {
      const newTxn = await recheckTransaction(navigate, { transactionId });
      if (!newTxn?.transaction) {
        throw newTxn;
      }
      setSelectedTxn(newTxn?.transaction);
      showAlert({
        color: 'success',
        title: 'Transaction status checked'
      });
    } catch (e) {
      showAlert({
        color: 'warning',
        title: "Couldn't check the transaction status",
        message: JSON.stringify(e)
      });
    }
    stopLoading();
  }, [loading, startLoading, stopLoading, navigate, transactionId]);

  return (
    <Modal
      isOpen={isOpen}
      className="w-3/4"
      title={`Raw responses ${transactionId}`}
      handleOpen={typeof transactionId === 'number'}
      handleClose={handleClose}>
      <Button
        style="outlined"
        onClick={transactionCheck}
        isLoading={loading}
        iconRight="rotate-ccw-linear"
        text="Check new transaction status"
      />
      {iaRa(selectedTxn?.raw_response).map((rawResponse, index) => (
        <div key={`transaction-${transactionId}-raw-response-index-${index}`}>
          {index && <hr />}
          <JsonView className="json-tree-view" src={rawResponse} collapsed={false} />
        </div>
      ))}
    </Modal>
  );
};

export default withErrorBoundary(TransactionResponseModal);
